import { useState, useCallback } from 'react'
import Cropper from 'react-easy-crop'
import './ImageCropModal.css'

export default function ImageCropModal({ imageUrl, initialCrop, onSave, onClose }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedArea, setCroppedArea] = useState(null)

  const onCropComplete = useCallback((croppedAreaPercent, croppedAreaPixels) => {
    // croppedAreaPercent gives us { x, y, width, height } as percentages (0-100)
    setCroppedArea(croppedAreaPercent)
  }, [])

  const handleSave = () => {
    // Calculate the center of the cropped area as percentages
    // This will be used for CSS object-position
    const centerX = croppedArea ? croppedArea.x + croppedArea.width / 2 : 50
    const centerY = croppedArea ? croppedArea.y + croppedArea.height / 2 : 50

    onSave({
      x: centerX,
      y: centerY
    })
  }

  return (
    <div className="modal-overlay crop-modal-overlay" onClick={onClose}>
      <div className="modal-content crop-modal" onClick={e => e.stopPropagation()}>
        <h2>Adjust Image Position</h2>

        <div className="crop-container">
          <Cropper
            image={imageUrl}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            cropShape="rect"
            showGrid={false}
          />
        </div>

        <div className="crop-controls">
          <label className="zoom-control">
            <span>Zoom</span>
            <input
              type="range"
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
            />
            <span className="zoom-value">{zoom.toFixed(1)}x</span>
          </label>
        </div>

        <p className="help-text">Drag to reposition. Use zoom to select area.</p>

        <div className="modal-actions">
          <button
            type="button"
            className="btn btn-ghost"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
          >
            Save Position
          </button>
        </div>
      </div>
    </div>
  )
}
